import React from 'react';
import { Table, TablePaginationConfig } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { ActionColumn, ImageColumn } from './column';
import { GRAPHICS } from '../../../constants/define/translation';
import { IndexColumn } from '../shared-column';
import { appStyles } from '../../../styles';

interface GraphicsTableProps {
  records?: any[];
  loading?: boolean;
  className?: string;
  pagination?: TablePaginationConfig;
  onRefresh?: (loading?: boolean) => void;
  onLoading: (loading: boolean) => void;
}

const { Column } = Table;
export const GraphicsTable = (props: GraphicsTableProps) => {
  const { t } = useTranslation(GRAPHICS);
  const { records, pagination, onRefresh, onLoading } = props;

  return (
    <>
      <StyledTable
        dataSource={records}
        loading={props.loading}
        className={props.className}
        rowKey="index"
        pagination={pagination}
      >
        <Column
          title={t('table.title.index')}
          align="center"
          width={32}
          dataIndex="index"
          key="index"
          render={(value, record: any) => <IndexColumn value={value} />}
        />
        <Column
          title={t('table.title.link')}
          align="center"
          dataIndex="link"
          key="link"
          render={(value, record: any) => <ImageColumn record={record} />}
        />
        <Column
          title={t('table.title.action')}
          align="center"
          width={60}
          render={(value, record: any) => <ActionColumn record={record} onRefresh={onRefresh} onLoading={onLoading} />}
        />
      </StyledTable>
    </>
  );
};

const StyledTable = styled(Table)`
  .ant-table-thead {
    border-bottom: 2px solid #eee;
    & > th > tr {
      ${appStyles.background.tableBgGray}
      text-transform: uppercase;
      font-size: 0.75rem;
      font-weight: 600;
      border: 1px solid #dededee3;
      &:before {
        display: none;
      }
    }
  }

  .ant-pagination-item a {
    line-height: 30px;
  }
`;
